import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/admin/dashboard", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-ink/15 p-10">
        <Logo />
        <p className="mt-2 text-xs uppercase tracking-[0.25em] text-ink/40">Content Management</p>
        <h1 className="mt-8 font-serif text-3xl tracking-tight text-ink">Sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] font-medium text-ink/60 mb-1">Email</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              autoComplete="email" data-testid="admin-email-input"
              className="w-full border-b border-ink/25 py-3 text-base focus:outline-none focus:border-burgundy transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] font-medium text-ink/60 mb-1">Password</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              autoComplete="current-password" data-testid="admin-password-input"
              className="w-full border-b border-ink/25 py-3 text-base focus:outline-none focus:border-burgundy transition-colors"
            />
          </div>
          {error && <p className="text-sm text-burgundy" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-burgundy text-cream text-xs uppercase tracking-[0.22em] font-bold px-8 py-4 transition-colors hover:bg-ink disabled:opacity-60 inline-flex items-center justify-center gap-3"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
